<template>
  <div class="container">
    <nav class="top-navbar fixed-top text-center">
      <a href="#/" target="_self" class="navbar-brand m-2">
        <img src="/img/svg/expense_guide_logo_inside.svg" alt="expense.guide logo" class="logo-topnav">
      </a>
    </nav>
    <div class="row justify-content-center">
      <div class="col">
        <div class="card card-default">
          <div class="card-header">Reset Password</div>

          <div class="card-body">
            <div v-if="error" class="alert alert-danger">{{ error }}</div>
            <div v-if="message" class="alert alert-info">{{ message }}</div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">Token</label>

              <div class="col-md-6">
                <input id="token" v-model="form.token" :class="{ 'is-invalid': errors.token }" type="email" class="form-control" required readonly>
                <span v-if="errors.token" class="invalid-feedback">
                  <div v-for="(error, index) in errors.token" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="email" class="col-md-4 col-form-label text-md-right">E-Mail Address</label>

              <div class="col-md-6">
                <input id="email" v-model="form.email" :class="{ 'is-invalid': errors.email }" type="email" class="form-control" required>
                <span v-if="errors.email" class="invalid-feedback">
                  <div v-for="(error, index) in errors.email" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row">
              <label for="new-password" class="col-md-4 col-form-label text-md-right">New password</label>

              <div class="col-md-6">
                <input id="new-password" v-model="form.password" :class="{ 'is-invalid': errors.password }" type="password" class="form-control" required>
                <span v-if="errors.password" class="invalid-feedback">
                  <div v-for="(error, index) in errors.password" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>
            <div class="form-group row">
              <label for="new-password" class="col-md-4 col-form-label text-md-right">New password confirm</label>

              <div class="col-md-6">
                <input id="new-password-confirm" v-model="form.password_confirmation" :class="{ 'is-invalid': errors.password_confirmation }" type="password" class="form-control" required>
                <span v-if="errors.password_confirmation" class="invalid-feedback">
                  <div v-for="(error, index) in errors.password_confirmation" :key="index"><strong>{{ error }}</strong></div>
                </span>
              </div>
            </div>

            <div class="form-group row mb-0">
              <div class="col-md-6 offset-md-4">
                <button type="submit" class="btn btn-primary" @click.prevent="submit()">
                  <span v-if="this.$loading.isLoading('password-resetting')"><i class="pe pe-spinner fa-spin" aria-hidden="true"/></span> Reset Password
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'PasswordReset',
  data () {
    return {
      form: {
        token: this.$route.params.token,
        email: '',
        password: '',
        password_confirmation: ''
      },
      message: '',
      error: '',
      errors: {}
    }
  },
  methods: {
    ...mapActions([
      'resetPassword'
    ]),
    submit () {
      this.$loading.startLoading('password-resetting')
      this.errors = {}
      this.resetPassword(this.form)
        .then((data) => {
          this.error = ''
          this.message = data.message
          this.form.token = ''
          this.form.email = ''
          this.form.password = ''
          this.form.password_confirmation = ''
          this.$loading.endLoading('password-resetting')
        })
        .catch((data) => {
          this.message = ''
          this.error = data.message
          this.errors = data.errors || {}
          this.$loading.endLoading('password-resetting')
        })
    }
  }
}
</script>
